import { companyConfig } from "../config";
import Bundle from "./Bundle";
import CreditCheckResult from "./CreditCheckResult";
import Product from "./Product";

export function denormalizeAgreementKey(agreementKey: string): string {
  if (typeof agreementKey !== 'string') {
    return agreementKey;
  }
  if (!agreementKey.startsWith('avtal_')) {
    agreementKey = 'avtal_' + agreementKey;
  }

  if (!agreementKey.endsWith('.pdf')) {
    agreementKey += '.pdf';
  }

  return agreementKey;
}

export function normalizeAgreementKey(agreementKey) {
  if (typeof agreementKey !== 'string') {
    return agreementKey;
  }
  return agreementKey.replace('avtal_', '').replace('.pdf', '');
}

export function getAgreementHref(agreementKey: string) {
  return new URL(denormalizeAgreementKey(agreementKey), companyConfig.agreementWebsite).href;
}

export class Agreement {
  readonly key: string;
  readonly uri: string;

  constructor(deriveFrom?: Partial<Agreement>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    if (this.key && !this.uri) {
      this.uri = getAgreementHref(this.key);
    }
  }
}

/**
 * Represents a person to sign an agreement.
 */
export class AgreementSignee extends CreditCheckResult {
  signatureUri?: string;

  constructor(deriveFrom?: Partial<AgreementSignee>) {
    super(deriveFrom);
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }
}

export enum AgreementSigningMethod {
  Manual = 'manual',
  Sms = 'sms'
}

export type CreateAgreementParams = {
  signee: AgreementSignee;
  subscriptions: Product[];
  bundles: Bundle[];
  ssn?: string;
  date?: Date;
  monthlyPaymentTotal: number;
  
  /**
   * Körkort.
   */
  photo?: Blob;
};